import Vue from 'vue'
import App from './App.vue'
import MyPlugin from './utils/MyPlugin'
import 'lib-flexible'
import router from './router'
import store from './store'
import { axios } from '@/servers/axios'
import './assets/css/css.css'
import './utils/Adaptive'
import { Swipe, SwipeItem,Field,Popup,Picker,Form,Switch,Button,Tab,Tabs,RadioGroup, Radio, Loading  } from 'vant';
import 'vant/lib/index.css'

Vue.use(MyPlugin)
Vue.use(Form)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Button)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Loading);


Vue.config.productionTip = false

// import vConsole from '@/utils/vconsole.js'
// fromData请求
Vue.prototype.axios = axios


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
